import api, { apiSetup } from '../api';

apiSetup();

export class TypesService {
  BASE_URL = '/types';

  get() {
    return api.get(this.BASE_URL);
  }
}
